export default __webpack_public_path__ + "static/media/content-img-2.5cc72f4c.webp";